export class NestedSilverfinCompany {
    id = 0;
    name = '';

    deserialize(data: any) {
        this.id = data.id ?? 0;
        this.name = data.name ?? '';
        return this;
    }
}
